// import React from 'react';
// import Slider from 'react-slick';

// // The Testimonials component takes `testimonials` and `title` as props
// const Testimonials = ({ testimonials, title = "Love from our Clients" }) => {

//   // Slick slider settings for auto sliding
//   const settings = {
//     dots: true,               // Show dots for navigation
//     infinite: true,           // Infinite looping
//     speed: 500,               // Speed of sliding (in ms)
//     autoplay: true,           // Enable auto sliding
//     autoplaySpeed: 3000,      // Time delay between auto slides (in ms)
//     slidesToShow: 2,          // Show two slides at once
//     slidesToScroll: 1,        // Scroll one slide at a time
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2, // Show 2 slides on medium and larger screens
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1, // Show 1 slide on small screens (tablets or smaller)
//         },
//       },
//     ],
//   };

//   return (
//     <section className="testimonial-style-two white-bg py-3 centred">
//       <div className="auto-container">
//         <div className="sec-title mb_50">
//           <span className="sub-title">Testimonials</span>
//           <h2>{title}</h2>
//         </div>
//         <Slider {...settings} className="three-item-carousel owl-carousel owl-theme owl-nav-none">
//           {testimonials.map((testimonial, index) => (
//             <div key={index} className="testimonial-block-two">
//               <div className="inner-box">
             
//                 <h3>{testimonial.name}</h3>
//                 <ul className="rating">
//                   {testimonial.rating.map((star, index) => (
//                     <li key={index}>
//                       <img src="/images/icons/icon-1.png" alt={`star-${index}`} />
//                     </li>
//                   ))}
//                 </ul>
//                 <p>{testimonial.text}</p>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;
import React from 'react';
import Slider from 'react-slick';

const Testimonials = ({ testimonials, title = "Love from our Clients" }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="testimonial-style-two py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="auto-container">
        <div className="sec-title mb_50 text-center">
          <span className="sub-title" style={{ color: '#FF6403', fontWeight: 'bold' }}>Testimonials</span>
          <h2 style={{ color: '#333' }}>{title}</h2>
        </div>

        <Slider {...settings} className="testimonial-slider">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card p-3">
              <div className="testimonial-inner bg-white rounded shadow-sm p-4 h-100 d-flex flex-column justify-content-between">
                <div className="testimonial-header text-center mb-3">
                  <h3 style={{ color: '#FF6403', fontWeight: '600' }}>{testimonial.name}</h3>
                  <ul className="rating list-inline m-0">
                    {Array.from({ length: testimonial.rating.length }).map((_, i) => (
                      <li key={i} className="list-inline-item">
                        <span style={{ color: '#FF6403', fontSize: '18px' }}>★</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="testimonial-text text-muted text-center mt-3">"{testimonial.text}"</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
